<template>
  <b-col
    cols="12"
    lg="6"
    class="mb-4"
  >
    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            Campanhas WhatsApp AI
          </h4>
          <b-badge
            variant="light-primary"
            pill
          >
            {{ totalCampanhas }} campanhas
          </b-badge>
        </div>
      </template>

      <div
        class="chart-container"
        style="height: 300px;"
      >
        <!-- Se houver dados, mostrar gráfico -->
        <canvas
          v-if="hasData"
          ref="conversasChart"
        />

        <!-- Se não houver dados, mostrar placeholder -->
        <div
          v-else
          class="empty-state"
        >
          <div class="text-center py-5">
            <div class="mb-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-muted"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                <path d="M8 10h.01" />
                <path d="M12 10h.01" />
                <path d="M16 10h.01" />
              </svg>
            </div>
            <h5 class="text-muted mb-2">
              Campanhas WhatsApp
            </h5>
            <p class="text-muted mb-0 small">
              Dados de campanhas aparecerão aqui<br>
              quando houver atividade
            </p>
          </div>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import { BCol, BCard, BBadge } from 'bootstrap-vue'

export default {
  name: 'WhatsAppCampaignsCard',
  components: {
    BCol,
    BCard,
    BBadge,
  },
  props: {
    campanhas: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasData() {
      return this.campanhas && this.campanhas.length > 0
    },
    totalCampanhas() {
      return this.campanhas ? this.campanhas.length : 0
    },
  },
  watch: {
    campanhas: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.renderChart()
          })
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.hasData) {
      this.renderChart()
    }
  },
  methods: {
    renderChart() {
    },
  },
}
</script>

<style scoped>
.chart-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state svg {
  opacity: 0.5;
}
</style>
